import useModelContext from './useModelContext';
export default function useCurrentAuth() {
  const auth = useModelContext(s => s.auth);
  return auth;
}